import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const WorkingTimeInfoModal = ({ show, onHide }) => {
    const { t } = useTranslation();
    return (
        <Modal centered show={show} onHide={onHide}>
            <Modal.Header>
                <Modal.Title>{t('Why is working time important to fill in?')}</Modal.Title>
                <AiOutlineClose className="ml-auto cursor-pointer" size={24} onClick={onHide} />
            </Modal.Header>
            <Modal.Body>
                <p>
                    {t(
                        'When you invoice through Invozio, you are to be able to invoice without F-tax, employed by Invozio during the assignment period. We also want to be able to ensure that you work under good working conditions. The registered working hours form the basis for your employment and income information, including the social insurance office and employment certificate.'
                    )}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button className="text-light" variant="primary" onClick={onHide}>
                    {t('Close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default WorkingTimeInfoModal;